module.exports = __webpack_public_path__ + "static/st1-5-a333cb1e32e43efa20071cd42f926fd5.jpg";